import { useState } from "react";
import { useAuthContext } from "./useAuthContext";

export const useCheckPassword = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(null);
    const [success, setSuccess] = useState(false);

    const { user } = useAuthContext();


    const checkPassword = async (username, password) => {
        setIsLoading(true);
        setError(null);
        setSuccess(false);

        const passwordResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/user/checkPassword`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ username, password })
        });

        const passwordJson = await passwordResponse.json();

        if (!passwordResponse.ok) {
            setError(passwordJson.error);
            // setSuccess(false);
            setIsLoading(false);
        } else {
            setSuccess(true);
            setIsLoading(false);
        }


    };
    return { checkPassword, success, isLoading, error };
}